import { useCallback, useMemo } from 'react';
import { useAuth } from 'react-oidc-context';

function decodeJwt(token?: string) {
  if (!token) return null;
  try {
    return JSON.parse(atob(token.split('.')[1] || ''));
  } catch {
    return null;
  }
}

export const useGetAccessTokenPayload = (): Record<string, any> & {
  accessToken: string | null;
  refreshToken: string | null;
  refreshTokenData: Record<string, any>;
  isEnable2FA: boolean;
  refresh: () => Promise<void>;
} => {
  const auth = useAuth();

  const parsedAccess = useMemo(() => decodeJwt(auth.user?.access_token), [auth.user?.access_token]);

  // const parsedRefresh = useMemo(
  //   () => decodeJwt(auth.user?.refresh_token),
  //   [auth.user?.refresh_token],
  // );

  const isEnable2FA = useMemo(() => {
    return parsedAccess?.realm_access?.roles?.includes('require_otp_role') || false;
  }, [parsedAccess, auth.user?.access_token]);

  const doRefresh = useCallback(async () => {
    if (!auth.user?.refresh_token) return;

    try {
      await auth.signinSilent(); //refreshAccessToken
    } catch (err) {
      console.error('Token refresh failed', err);
      auth.removeUser();
    }
  }, [auth]);

  return {
    ...parsedAccess,
    accessToken: auth.user?.access_token || null,
    refreshToken: auth.user?.refresh_token || null,
    isEnable2FA,
    refresh: doRefresh,
  };
};
